import styles from "../../styles/Header.module.css"
import { Avatar, IconButton } from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu"
import ProfileMenu from "./ProfileMenu"
import { Dispatch, SetStateAction, useState } from "react"
import { useUserInfo } from "../../helpers/customHooks/useUserInfo"
import SearchBar from "./SearchBar"
import { useSearchParams } from "next/navigation"
import { updateUrlParams } from "@/app/helpers/utils/navigation"
import Image from "next/image"

interface HeaderProps {
  setSideBarCollapsed: Dispatch<SetStateAction<boolean>>
}

export default function Header({ setSideBarCollapsed }: HeaderProps) {
  const [showProfileMenu, setShowProfileMenu] = useState(false)

  const userInfo = useUserInfo()
  const searchParams = useSearchParams()

  const handleLogoClick = () => {
    updateUrlParams(searchParams, { view: undefined })
  }

  return (
    <div className={styles.container}>
      <div className={styles.containerLeft}>
        <div className={styles.menuButtonContainer}>
          <IconButton
            aria-label="menu"
            size="large"
            onClick={() => setSideBarCollapsed((collapsed) => !collapsed)}
            disableFocusRipple
          >
            <MenuIcon />
          </IconButton>
        </div>
        <div className={styles.logo} onClick={handleLogoClick}>
          {/* <img src="/chronos_logo.png" alt="Chronos Logo" /> */}
          <Image
            src="/chronos_logo.png"
            alt="Chronos Logo"
            width={120}
            height={40}
          />
        </div>
      </div>

      <SearchBar />

      <div className={styles.containerRight}>
        <IconButton
          aria-label="profile"
          onClick={() => setShowProfileMenu(!showProfileMenu)}
          size={"small"}
          sx={{
            color: showProfileMenu ? "primary.main" : "default",
            backgroundColor: showProfileMenu
              ? "rgba(0, 0, 0, 0.08)"
              : "transparent",
            "&:hover": {
              backgroundColor: showProfileMenu
                ? "rgba(0, 0, 0, 0.08)"
                : "rgba(0, 0, 0, 0.04)",
            },
          }}
          disableRipple={true}
        >
          <Avatar
            alt={userInfo?.name}
            src={userInfo?.picture}
            sx={{ width: 36, height: 36 }}
          />
        </IconButton>
        <ProfileMenu
          isOpen={showProfileMenu}
          setIsOpen={setShowProfileMenu}
          userInfo={userInfo}
        />
      </div>
    </div>
  )
}
